import { Component, inject } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { AUTH_FACADE } from '@dges/modules/auth/domain';
import { Router } from '@angular/router';
import { LoginFormComponent } from '@dges/forms/login-form';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'dges-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, LoginFormComponent, MatButton],
})
export class LoginPageComponent {
  private authFacade = inject(AUTH_FACADE);
  private router = inject(Router);

  form = new UntypedFormGroup({
    loginForm: new UntypedFormControl({
      emailFormControl: '',
      passwordFormControl: '',
    }),
  });

  login() {
    this.authFacade.login(
      this.emailFormControlValue,
      this.passwordFormControlValue,
    );
  }

  loginWithGoogle() {
    this.authFacade.loginWithGoogle();
  }

  get emailFormControlValue() {
    return this.form.controls.loginForm.value.emailFormControl;
  }

  get passwordFormControlValue() {
    return this.form.controls.loginForm.value.passwordFormControl;
  }
}
